import  { useState } from "react";
import {
  
  Typography,
  Paper,
  Grid,
  Chip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Container,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Layout from "../components/layout/Calayout";

const ComplianceTracking = () => {
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const [selectedCompliance, setSelectedCompliance] = useState(null);


  const complianceData = [
    {
      id: 1,
      regulation: "GDPR",
      status: "Compliant",
      lastReviewed: "2024-03-15",
      nextReview: "2024-09-15",
      riskLevel: "Low",
      documentationScore: 95,
    },
    {
      id: 2,
      regulation: "CCPA",
      status: "Partially Compliant",
      lastReviewed: "2024-02-01",
      nextReview: "2024-08-01",
      riskLevel: "Medium",
      documentationScore: 75,
    },
    {
      id: 3,
      regulation: "SOX",
      status: "Non-Compliant",
      lastReviewed: "2024-01-10",
      nextReview: "2024-07-10",
      riskLevel: "High",
      documentationScore: 60,
    },
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case "Compliant": return "success";
      case "Partially Compliant": return "warning";
      case "Non-Compliant": return "error";
      default: return "default";
    }
  };

  const columns = [
    {
      field: "regulation",
      headerName: "Regulation",
      flex: 1,
    },
    {
      field: "status",
      headerName: "Compliance Status",
      flex: 1,
      renderCell: (params) => (
        <Chip
          label={params.value}
          color={getStatusColor(params.value)}
          variant="outlined"
        />
      ),
    },
    {
      field: "lastReviewed",
      headerName: "Last Reviewed",
      flex: 1,
    },
    {
      field: "nextReview",
      headerName: "Next Review",
      flex: 1,
    },
    {
      field: "riskLevel",
      headerName: "Risk Level",
      flex: 1,
      renderCell: (params) => {
        const riskColor = {
          Low: "success",
          Medium: "warning",
          High: "error",
        }[params.value];

        return <Chip label={params.value} color={riskColor} size="small" />;
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={() => {
            setSelectedCompliance(params.row);
            setOpenDetailsDialog(true);
          }}
        >
          View Details
        </Button>
      ),
    },
  ];

  const handleCloseDetailsDialog = () => {
    setOpenDetailsDialog(false);
    setSelectedCompliance(null);
  };

  return (
    <Layout>
      <Container maxWidth="xl">
        <Typography variant="h4" gutterBottom>
          Compliance Tracking
        </Typography>

        <Paper sx={{ width: "100%", mb: 2 }}>
          <DataGrid
            rows={complianceData}
            columns={columns}
            components={{
              Toolbar: GridToolbar,
            }}
            pageSize={5}
            rowsPerPageOptions={[5]}
            checkboxSelection
            disableSelectionOnClick
            autoHeight
          />
        </Paper>

        <Dialog
          open={openDetailsDialog}
          onClose={handleCloseDetailsDialog}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            Compliance Details: {selectedCompliance?.regulation}
          </DialogTitle>
          <DialogContent>
            {selectedCompliance && (
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle1">
                    Compliance Overview
                  </Typography>
                  <Typography>Status: {selectedCompliance.status}</Typography>
                  <Typography>
                    Last Reviewed: {selectedCompliance.lastReviewed}
                  </Typography>
                  <Typography>
                    Next Review: {selectedCompliance.nextReview}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle1">Risk Assessment</Typography>
                  <Typography>
                    Risk Level: {selectedCompliance.riskLevel}
                  </Typography>
                  <Typography>
                    Documentation Score:{" "}
                    {selectedCompliance.documentationScore}%
                  </Typography>
                </Grid>
              </Grid>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDetailsDialog} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Layout>
  );
};

export default ComplianceTracking;
